module.exports = {
  // BASE_API: 'https://www.evoxsystem.com/evokey',
  // BASE_API: "https://www.evoxs.cn/evokey",
  BASE_API: "http://192.168.0.14:50050",
  mqttUrl: "wss://evoxs.cn/ws/",
  //ws://3.71.74.65:15675/ws ws://192.168.0.20:15675/ws
};



//////////////////
// WEBPACK FOOTER
// ./static/config/api.js
// module id = MpgJ
// module chunks = 25